import React from 'react';
import MyGallery from "../Gallery/MyGallery";
import './ServicesPage.css';
import {useTranslation} from "react-i18next";

function LivingRoomPage() {
    const { t } = useTranslation();
    const directory= "/images/saloni/";
    const filenames=[
        'VPR03393_Vasso_Paraschi.webp',
        'VPR03405_Vasso_Paraschi.webp',
        'VPR03422_Vasso_Paraschi.webp',
        'VPR03431_Vasso_Paraschi.webp'
    ];

    return (
        <div className="services-page">
            <h1>{t("Living Rooms")}</h1>
            <div className="services-info-container">
                <MyGallery directory={directory} filenames={filenames} />
            </div>

        </div>
    );
}

export default LivingRoomPage;
